import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from '../../app.service';
import { UsuarioHttpService } from '../../http-services/usuario-http.service';
import { AddressService } from '../../utils/services/address.service';
import handleErrorMessage from '../../utils/services/error-message-handler';
import { MessageService } from '../../utils/services/message.service';
import { UtilsService } from '../../utils/services/utils-service';

@Component({
  selector: 'app-usuario-add',
  templateUrl: './usuario-add.component.html',
  styleUrl: './usuario-add.component.scss'
})
export class UsuarioAddComponent implements OnInit {

  public form: FormGroup
  public submitted = false;
  public show: boolean = false;
  estados: any[];

  constructor(
    private _fb: FormBuilder,
    private _utilsService: UtilsService,
    private _addressService: AddressService,
    private _messageService: MessageService,
    private _appService: AppService,
    private _usuarioHttpService: UsuarioHttpService,
    private _location: Location,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.estados = this._utilsService.loadBrazilStates();
  }

  /**
   * Método de inicialização dos formulários;
   */
  public initForm() {
    this.form = this._fb.group({
      usuarioId: [null],
      nome: ['', [Validators.required, Validators.minLength(3)]],
      numeroDocumento: ['', [Validators.required, Validators.minLength(11)]],
      email: ['', [Validators.required, Validators.email]],
      senha: ['', Validators.required],
      ddd: ['', Validators.required],
      telefone: ['', Validators.required],
      ativo: [true],
      endereco: this._fb.group({
        enderecoId: [null],
        cep: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
        rua: ['', [Validators.required]],
        numero: ['', [Validators.required]],
        complemento: [''],
        cidade: ['', [Validators.required]],
        bairro: ['', [Validators.required]],
        estado: ['', [Validators.required]],
        pais: ['Brasil'],
      })
    });
  }

  async submit() {

    this.form.markAllAsTouched();
    this.submitted = true;

    if (this.form.valid) {
      const usuario = this.form.value;

      const confirmation = await this._appService.fireSwalAsync('Atenção', 'Deseja Realmente salvar?', 'Salvar');

      if (confirmation) {
        this._usuarioHttpService.save(usuario).subscribe({
          next: (result) => {
            this._messageService.show('Atenção', 'Registro salvo com sucesso!', 'success');
            this.form.reset();
          },
          error: (err) => {
            console.log(err);
            handleErrorMessage(this._messageService, err);
          }
        })
      }

    } else {
      this._messageService.show('Atenção', 'Preencha todos os Campos', 'warning');
    }
  }

  voltar() {
    this._location.back();
  }

  showPassword() {
    this.show = !this.show;
  }

  /**
 * Função para buscar o endereço a partir do CEP digitado;
 */
  onBlurCep() {
    this._addressService.getAddressByCep(this.enderecoForm.get('cep').value).subscribe(
      (result) => {

        if (result.erro != undefined && result.erro) {
          this._messageService.show('Atenção', 'CEP digitado está inválido ou não foi encontrado.', 'warning');
        } else {
          let state = this.estados.filter(s => s.uf === result.uf)[0];

          this.enderecoForm.get('rua').setValue(result.logradouro);
          this.enderecoForm.get('bairro').setValue(result.bairro);
          this.enderecoForm.get('complemento').setValue(result.complemento);
          this.enderecoForm.get('cidade').setValue(result.localidade);
          this.enderecoForm.get('estado').setValue(state.name);
        }

      },
      (error: any) => {
        console.log(error);
      }
    )
  }

  /**
  * get do formulário geral;
   */
  get f() {
    return this.form.controls;
  }

  /**
   * get do formulário endereço;
   */
  get enderecoForm() {
    return this.f.endereco;
  }

}
